var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useSubscription } from '@apollo/client';
import { Col, Spin, Popconfirm } from 'antd';
import { getListWithBlobSrc } from 'utils/helpers';
import { prototimeToDate } from 'utils/prototime';
import UPLOAD_EVENTS from 'apollo/subscriptions/UPLOAD_EVENTS';
import useDebouncedFunction from 'utils/hooks/useDebouncedFunction';
import { StyledRow } from 'components/CreateTicketModal/RequestData/styled';
import getScanStatus from 'utils/helpers/scanStatusHelper';
import { Input, TextArea, Button, Select } from 'ui/styled';
import { BLUE } from 'ui/constants';
import { useSubscription as useRtgSubscription } from '@rightway/websocket-multiplexer';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { DownloadImage, Attachment, AttachmentIcon, AttachmentContainer } from '../styled';
var Attachments = function (_a) {
    var _b = _a.attachments, attachments = _b === void 0 ? [] : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.updateHandler, updateHandler = _d === void 0 ? function () { } : _d, _e = _a.removeHandler, removeHandler = _e === void 0 ? function () { } : _e, _f = _a.attachmentOptions, attachmentOptions = _f === void 0 ? null : _f;
    var _g = useState([]), billsWithBucketSrc = _g[0], setBillsWithBucketSrc = _g[1];
    var _h = useState(attachments.length > 0), loading = _h[0], setLoading = _h[1];
    var _j = useRtgSubscription(), subscriptionMessages = _j.subscriptionMessages, subscribeToEvent = _j.subscribeToEvent;
    var enableUploadEvent = useFlags().enableUploadEvent;
    useEffect(function () {
        var loadImages = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        return [4 /*yield*/, getListWithBlobSrc(attachments, setBillsWithBucketSrc)];
                    case 1:
                        _a.sent();
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        loadImages();
    }, [attachments.length]);
    useEffect(function () {
        if (!enableUploadEvent)
            return;
        var unsubscribe = subscribeToEvent({
            eventName: 'uploadCreated',
            params: {}
        });
        return function () { return unsubscribe(); };
    }, [subscribeToEvent, enableUploadEvent]);
    var combinedData = useMemo(function () {
        var _a, _b;
        if (!enableUploadEvent)
            return billsWithBucketSrc;
        var eventKey = (_a = Array.from(subscriptionMessages.keys()).find(function (key) {
            return key.startsWith('uploadCreated');
        })) !== null && _a !== void 0 ? _a : '';
        var eventData = (_b = subscriptionMessages.get(eventKey)) !== null && _b !== void 0 ? _b : [];
        if (!subscriptionMessages.size || eventData.length === 0) {
            return billsWithBucketSrc;
        }
        return billsWithBucketSrc.map(function (item) {
            var latestEvent = eventData
                .map(function (msg) { return msg.payload.data; })
                .filter(function (event) { return event.id === item.id; })
                .sort(function (a, b) {
                return prototimeToDate(b.createdAt).getTime() -
                    prototimeToDate(a.createdAt).getTime();
            })[0];
            if (latestEvent) {
                return __assign(__assign({}, item), { scan_status: latestEvent.scanStatus, short_url: latestEvent.shortUrl });
            }
            return item;
        });
    }, [billsWithBucketSrc, subscriptionMessages, enableUploadEvent]);
    var showSelect = !!(attachmentOptions === null || attachmentOptions === void 0 ? void 0 : attachmentOptions.length);
    // TODO: remove once we fully migrate to RTG
    var setAttachmentStatus = function (id, scan_status, short_url) {
        var item = __assign({}, billsWithBucketSrc.find(function (i) { return i.id === id; }));
        item.scan_status = scan_status;
        item.short_url = short_url;
        // Change file status in the state
        setBillsWithBucketSrc(billsWithBucketSrc.map(function (i) { return (i.id !== id ? i : item); }));
    };
    // TODO: remove once we fully migrate to RTG
    useSubscription(UPLOAD_EVENTS, {
        skip: !!enableUploadEvent,
        onData: function (_a) {
            var _b = _a.data.data.upload_events.upload, id = _b.id, scan_status = _b.scan_status, short_url = _b.short_url;
            setAttachmentStatus(id, scan_status, short_url);
        }
    });
    var updateAttachment = useCallback(function (id, key, value) {
        var _a;
        return updateHandler([(_a = { id: id }, _a[key] = value, _a)]);
    }, [updateHandler]);
    var removeAttachment = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, removeHandler(id)];
                case 1:
                    _a.sent();
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var debouncedUpdateAttachment = useDebouncedFunction(updateAttachment, 500);
    if (!attachments.length)
        return null;
    return (_jsx(Spin, { spinning: loading, children: combinedData.map(function (item) {
            var id = item.id, src = item.src, content_type = item.content_type, title = item.title, notes = item.notes, scan_status = item.scan_status;
            if (!content_type)
                return null;
            var isPdf = content_type.match('application');
            var fileComponent = (_jsx("a", { href: src, target: "_blank", rel: "noopener noreferrer", children: isPdf ? (_jsx(AttachmentIcon, { type: "file" })) : (_jsx(DownloadImage, { src: src, alt: "thumbnail" })) }));
            return (_jsxs(StyledRow, { gutter: 16, children: [_jsx(Col, { span: 6, children: _jsx(AttachmentContainer, { children: _jsx(Attachment, { children: getScanStatus(scan_status, fileComponent) }, id) }) }), _jsxs(Col, { span: 18, children: [_jsxs(StyledRow, { gutter: 16, children: [_jsx(Col, { span: 18, children: showSelect ? (_jsx(Select, { defaultValue: title, placeholder: "Title", onChange: function (value) {
                                                return debouncedUpdateAttachment(item.id, 'title', value);
                                            }, "data-test": "attachmentsTitleSelect", options: attachmentOptions })) : (_jsx(Input, { disabled: disabled, defaultValue: title, placeholder: "Title", onChange: function (e) {
                                                return debouncedUpdateAttachment(item.id, 'title', e.target.value);
                                            }, "data-test": "attachmentsTitleInput" })) }), _jsx(Col, { span: 6, children: _jsx(Popconfirm, { title: "Are you sure you want to delete this attachment?", onConfirm: function () { return removeAttachment(id); }, disabled: disabled || loading, okButtonProps: {
                                                'data-test': 'ticketPopconfirmRemoveOkBtn',
                                                style: {
                                                    backgroundColor: BLUE,
                                                    borderColor: BLUE,
                                                    borderRadius: 6
                                                }
                                            }, cancelButtonProps: {
                                                'data-test': 'ticketPopconfirmRemoveCancelBtn',
                                                style: {
                                                    borderRadius: 6
                                                }
                                            }, children: _jsx(Button, { btntype: "danger", width: "100%", disabled: disabled || loading, "data-test": "ticketRemoveAttachmentBtn", children: "Remove" }) }) })] }), _jsx(StyledRow, { gutter: 16, children: _jsx(Col, { span: 24, children: _jsx(TextArea, { disabled: disabled, rows: 5, defaultValue: notes, placeholder: "Notes", onChange: function (e) {
                                            return debouncedUpdateAttachment(item.id, 'notes', e.target.value);
                                        } }) }) })] })] }, id));
        }) }));
};
export default Attachments;
